import { __ } from '../../utils/i18n.js';

const EMAIL_REGEXP = /^(([^<>()[\]\\.,;:\s@"\u00C0-\u017F]+(\.[^<>()[\]\\.,;:\s@"\u00C0-\u017F]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-0-9\u00C0-\u017F]+\.)+[a-zA-Z]{2,}))$/;
function validEmailAddress(email) {
    if (!EMAIL_REGEXP.test(email)) {
        return __("Érvénytelen e-mail cím!");
    }
}

export { validEmailAddress };
//# sourceMappingURL=FormEmail.fn.js.map
